import { useMatch } from "react-router-dom-v5-compat";

import { ROUTES } from "routing/routes";

export function useIsOnCourseExamQuestions() {
  return useMatch(`${ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.path}/*`);
}

export function useIsOnCourseExamQuestionsSelectMode() {
  return !!useMatch(ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.SELECT_MODE.path);
}

export function useIsOnCourseExamQuestionsHomepage() {
  const onPractice = !!useMatch(
    `${ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.PRACTICE.path}/*`
  );
  const onMock = !!useMatch(
    `${ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.MINI_MOCK.path}/*`
  );
  const onSelectMode = !!useMatch(
    `${ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.SELECT_MODE.path}/*`
  );

  return onPractice || onMock || onSelectMode;
}

export function useIsOnCourseExamQuestionsMockSession() {
  return !!useMatch(
    `${ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.MINI_MOCK.SESSION.path}/*`
  );
}
